import { Component } from '@angular/core';
import { CatalogsSelectorComponent } from '../catalogs-selector/catalogs-selector.component';
import { ProductCardComponent } from '../product-card/product-card.component';
import { ContentService } from '../../services/content.service';
import { CategoryService } from '../../services/category.service';
import { ProductService } from '../../services/product.service';

@Component({
  selector: 'app-product-section',
  standalone: true,
  imports: [CatalogsSelectorComponent, ProductCardComponent],
  templateUrl: './product-section.component.html',
  styleUrl: './product-section.component.scss'
})
export class ProductSectionComponent {
  catalogs = [];
  products = [];

  constructor(
    private categoriesService: CategoryService,
    private productService: ProductService
  ) { }

  ngOnInit() {
    this.getCategories();
    this.getProduct();
  }

  getCategory(catalog: any = ''){
    this.getProduct(catalog);
  }

  getCategories() {
    this.categoriesService.getCategories().subscribe((res: any) => {
      this.catalogs = res;
    });
  }

  getProduct(catalog?: any) {
    this.productService.getProductByMainCategories(catalog?.categoria ?? '').subscribe((res: any) => {
      this.products = res;
    });
  }

}
